<section class="content">
  <div class="card" style="padding:25px">

    <div class="container-fluid">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
      <div *ngIf="dataSource == null">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value"
          style="margin-left: 44%;margin-top: 16%;">
        </mat-progress-spinner>
      </div>
      <div class="row" *ngIf="dataSource != null">
        <div class="col-12" *ngIf="!icustomerService.is_icustomer_register_component">
          <button mat-fab color="primary" (click)="registerIcustomer()">
            <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
          </button>
          <table class="table table-bordered">
            <tr>
              <th style="    width: 12%;">Code
                <input matInput type="text" #code_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>
              <th style="    width: 12%;">Name
                <input matInput type="text" #name_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>
              <th style="    width: 12%;">Mobile
                <input matInput type="text" #mobile_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>
              <th style="    width: 10%;">Booth Code
                <input matInput type="text" #booth_code_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>
              <th style="width: 12%;">Customer Type
                <input matInput type="text" #customer_type_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>

              <!-- <th>Booth Type</th> -->
              <th style="width: 12%;">Booth Zone
                <input matInput type="text" #zone_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>
              <th style="width: 12%;">Pincode
                <input matInput type="text" #pincode_filter
                  style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
              </th>
              <th>Edit</th>
            </tr>
            <tr *ngFor="let data of dataSource
                  | globalSearch:'customer_code_id': code_filter.value
                  | globalSearch:'name': name_filter.value
                  | globalSearch:'mobile': mobile_filter.value
                  | globalSearch:'booth_code': booth_code_filter.value
                  | globalSearch:'customer_type': customer_type_filter.value
                  | globalSearch:'pincode': pincode_filter.value
                  | globalSearch:'booth_zone': zone_filter.value
                ">
              <td>{{data['customer_code_id']}}</td>
              <td>{{data['name']}}</td>
              <td>{{data['mobile']}}</td>
              <td>{{data['booth_code']}}</td>
              <td>{{data['customer_type']}}</td>
              <!-- <td>{{data['booth_type']}}</td> -->
              <td>{{data['booth_zone']}}</td>
              <td>{{data['pincode']}}</td>
              <td>
                <mat-icon (click)="editIcustomer(data)">edit</mat-icon>
              </td>
            </tr>
          </table>

        </div>
        <div class="col-8" *ngIf="icustomerService.is_icustomer_register_component">
          <div class="row">
            <div class="col"></div>
            <div class="col-1">
              <button mat-fab color="primary" (click)="hideIcustomerRegister()">
                <i class="material-icons">
                  clear
                </i>
              </button>
            </div>
          </div>
          <app-icustomer-register></app-icustomer-register>
        </div>
      </div>
    </div>
  </div>
</section>
